export default {
  // banner底部数据
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],

  // 三屏 方案1：智能硬件管控物理印章
  applicationScenariosList: [
    {
      title: '外带用印场景',
      descOne: '用印管理需求：①印章经常性需要外带使用',
      descTwo: '②分支机构投标、签约，需要使用总部印章',
      img: require('@/assets/images/landing-semsign/yycj_one.png'),
      footerDesc: '解决方案：便携式印章机外带印章，通过手机App/小程序实时发起申请授权及启动盖印，实时记录用印信息。',
    },
    {
      title: '固定用印场景',
      descOne: '用印管理需求：①集团总部与分子公司日常办公固定用印',
      descTwo: '②建立并管理日常办公数据库',
      img: require('@/assets/images/landing-semsign/yycj_two.png'),
      footerDesc: '解决方案：通过OA/App发起用印申请审批流，连接驱动多场景智能硬件终端，满足用印需求并管理用印记录。',
    },
    {
      title: '应急用印场景',
      descOne: '用印管理需求：①应急用印无需走审批流程直接盖印',
      descTwo: '②离线盖印并本机存储用印信息',
      img: require('@/assets/images/landing-semsign/yycj_three.png'),
      footerDesc: '解决方案：通过便携式印章机冗余双系统与指纹识别功能，实现应急直接盖印或离线盖印，实时用印数据本机存储，网络连接回复后自动上传用印数据。',
    },
  ],

  // 五屏 电子签章应用场景
  solutionInfo: {
    title: '电子签章应用场景',
    solutionList: [
      {
        title: '人事场景',
        imgSrc: require('@/assets/images/solutionRscj.png'),
        mobileImgSrc: require('@/assets/images/solutionRscjMobile.png'),
        des: '支持企业人事场景下员工入、离、调、转完整生命周期相关文件在线签署；人事场景文件从制作到签署完成归档全链路跟踪。',
        href: 'https://www.esign.cn/pcgw/jjfa/news/rlzycj/',
        orgImg: [
          require('@/assets/images/solutionLyl.jpg'),
          require('@/assets/images/solutionNdsd.png'),
          require('@/assets/images/solutionBj.png'),
        ],
      },
      {
        title: '采购场景',
        imgSrc: require('@/assets/images/solutionCgcj.png'),
        mobileImgSrc: require('@/assets/images/solutionCgcjMobile.png'),
        des: '支持企业采购场景下订单合同等相关文件的审批和在线签署；提高采购合同的签约和履行效率，助力企业数字化运营。',
        href: 'https://www.esign.cn/pcgw/jjfa/news/cgcj/',
        orgImg: [
          require('@/assets/images/solutionRy.png'),
          require('@/assets/images/solutionHkws.png'),
          require('@/assets/images/solutionLzlj.png'),
        ],
      },
      {
        title: '销售场景',
        imgSrc: require('@/assets/images/solutionXscj.png'),
        mobileImgSrc: require('@/assets/images/solutionXscjMobile.png'),
        des:
          '针对销售业务场景，应用先进便捷的电子签章技术，提供合法合规的电子签章解决方案，提高销售、经销、代理、加盟等合同的签约和履行效率，助力企业数字化运营。',
        href: 'https://www.esign.cn/pcgw/jjfa/news/xscj/',
        orgImg: [
          require('@/assets/images/solutionSy.png'),
          require('@/assets/images/solutionAglz.png'),
          require('@/assets/images/solutionWawj.png'),
        ],
      },
      {
        title: '物流场景',
        imgSrc: require('@/assets/images/solutionWlcj.png'),
        mobileImgSrc: require('@/assets/images/solutionWlcjMobile.png'),
        des:
          '针对企业物流业务场景，应用先进便捷的电子签章技术，提供合法合规的电子签章解决方案，提高采购物流、生产物流、销售物流的数字化效率，加速企业数字化转型。',
        href: 'https://esign.cn/pcgw/jjfa/news/qywlcj/',
        orgImg: [
          require('@/assets/images/solutionDbkd.png'),
          require('@/assets/images/solutionJl.png'),
          require('@/assets/images/solutionLb.png'),
        ],
      },
      {
        title: '财务场景',
        imgSrc: require('@/assets/images/solutionCwcj.png'),
        mobileImgSrc: require('@/assets/images/solutionCwcjMobile.png'),
        des:
          '针对企业财务场景，应用先进便捷的电子签章技术，提供合法合规的电子签章解决方案，提高财务合同、收据、对账单等的签约和履行效率，助力企业高效数字化运营。',
        href: 'https://www.esign.cn/pcgw/jjfa/news/cwcj/',
        orgImg: [
          require('@/assets/images/solutionAlbb.png'),
          require('@/assets/images/solutionHxyh.png'),
          require('@/assets/images/solutionNjyh.png'),
        ],
      },
    ],
    btnList: [
      {
        name: '人事场景',
        imgSrc: require('@/assets/images/fwcj1.png'),
      },
      {
        name: '采购场景',
        imgSrc: require('@/assets/images/fwcj2.png'),
      },
      {
        name: '销售场景',
        imgSrc: require('@/assets/images/fwcj3.png'),
      },
      {
        name: '物流场景',
        imgSrc: require('@/assets/images/fwcj4.png'),
      },
      {
        name: '财务场景',
        imgSrc: require('@/assets/images/fwcj5.png'),
      },
    ],
  },

  // 六屏 一站式签章管理平台
  powerInfo: {
    title: '一站式签章管理平台',
    powerList: [
      {
        imgSrc: require('@/assets/images/qspt.png'),
        desList: [
          {
            title: '审签一体',
            des: '支持审批流程与签署流程交叉对接；支持流程中会签、或签、加签等流程编排能力。',
          },
          {
            title: '灵活签署',
            des: '支持系统中发起流程并签署，且可通过与业务系统对接签署；支持骑缝章、自由签、AI智能手绘等多种签名方式。',
          },
        ],
      },
      {
        imgSrc: require('@/assets/images/ykzx.png'),
        desList: [
          {
            title: '物电一体',
            des: '电子印章和物理印章从制作、使用到作废的全生命周期管理。',
          },
          {
            title: '统一授权',
            des: '集团化与非集团化公司多级印章授权；电子印章与物理印章统一授权。',
          },
          {
            title: '统计分析',
            des: '支持多维度的印章统计分析视图。',
          },
        ],
      },
      {
        imgSrc: require('@/assets/images/wdzx.png'),
        desList: [
          {
            title: '签署文件标准化',
            des: '支持导入、在线编辑等形式固化多种格式的文件模板，支持固化签署流程；历史模板版本可追踪。',
          },
          {
            title: '一次采集，批量签署',
            des: '适用于需要让签署人提前填写信息，再执行签署的场景，可基于签署人提供的信息批量发起签署任务。',
          },
          {
            title: '文件归档',
            des: '支持系统内归档和多归档系统对接；支持从归档、审批、借阅、归还的全流程管理。',
          },
        ],
      },
      {
        imgSrc: require('@/assets/images/glpt.png'),
        desList: [
          {
            title: '精细化管控',
            des: '多维度权限管理，操作和查看权限分离，实现数据安全隔离。',
          },
          {
            title: '流程引擎',
            des: '灵活配置多业务节点的执行流程，制章、用印、模板、签署等可根据业务需求调整设定。',
          },
          {
            title: '多业务系统集成',
            des: '预置集成套件，通过简单配置即可与主流系统集成。',
          },
        ],
      },
      {
        imgSrc: require('@/assets/images/bdcz.png'),
        desList: [
          {
            title: '存证管理业务闭环',
            des:
              '支持在线预览存证证明、下载存证证明以及在线核验存证证明，形成业务闭环；存证模板样式与显示字段支持自定义，并可一键线上预览效果。',
          },
        ],
      },
    ],
    btnList: [
      {
        name: '签署中心',
        imgSrc: require('@/assets/images/qszxbtn.png'),
      },
      {
        name: '印控中心',
        imgSrc: require('@/assets/images/ykzxbtn.png'),
      },
      {
        name: '文档中心',
        imgSrc: require('@/assets/images/wdzxbtn.png'),
      },
      {
        name: '管理平台',
        imgSrc: require('@/assets/images/glptbtn.png'),
      },
      {
        name: '本地存证',
        imgSrc: require('@/assets/images/bdczbtn.png'),
      },
    ],
  },

  // 七屏 客户案例
  orgList: {
    title: '客户案例',
    orgTypeList: ['公共服务', '人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['ggfw', 'humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map(item => {
      return require(`@/assets/images/${item}.png`)
    }),
  },

  // 八屏 关于e签宝
  eQianBao: [
    {
      key: 1,
      text:
        'e签宝面向企业组织、政务服务，提供全球领先的电子合同电子签章全生命周期服务。e签宝具备安全可信的电子签名与智能履约平台、物电一体化的印章管理平台、身份认证系统、区块链证据保全与管理平台、完善的司法服务体系等先进应用。',
    },
    {
      key: 2,
      text:
        'e签宝是业内唯一一家入选《2020胡润全球独角兽榜》的中国电子签名企业；于2021年9月完成中国电子签名行业首个E轮融资，金额达12亿元；同月宣布战略并购金格科技。',
    },
    {
      key: 3,
      text:
        '截至2021年8月底，e签宝已服务100+世界五百强客户，200+中国五百强客户，与各级政府联创1500多个政务服务应用场景，与3000+生态伙伴实现深度融合，是浙江省“最多跑一次”指定电子签供应商。',
    },
  ],
}
